import R from 'ramda'

const ONE_TIME_CONSENT_DISPLAY_TYPE = 'Received One-Time Consent'
const ONE_TIME_CONSENT_TRIGGER_TYPE = 'OPT_IN_ONE_TIME'

const isOneTimeConsentWidgetTrigger = R.propEq(
  'type',
  ONE_TIME_CONSENT_TRIGGER_TYPE
)

const convertOneTimeConsentWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(ONE_TIME_CONSENT_DISPLAY_TYPE)
})

export {
  isOneTimeConsentWidgetTrigger,
  convertOneTimeConsentWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/widget-to-form/received-onetime-consent.js